import React from 'react';
import './css/navbar.css';
const Navbar = () => {
  return (
    <nav>
      <h1>iPodloga</h1>
    </nav>
  );
};

export default Navbar;
